import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Hidden from '@material-ui/core/Hidden';
import Cards from 'react-credit-cards';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import 'react-credit-cards/es/styles-compiled.css';
import CurrencyInputFormat from './CurrencyInputFormat';
import CardDetails from './CardDetails';
import Modal from 'react-modal';
import { fetchInvoices, toggleInvoice, toggleAllInvoices, changeAdhocAmount,successPaymentInprogress,getPaymentType } from './actions/invoice';
import { changeCreditAdhocAmount,toggleCredit } from './actions/credit';
import OpenModal from './OpenModal';
import ConfirmModal from './ConfirmModal';
import { history } from './store';
import  dateFormat  from 'dateformat';
import classNames from 'classnames';
// import card_visa from './images/card_visa.png';
// import card_master from './images/card_master.png';
import visa_master from './images/visa_master.png'

const styles = theme => ({
    root: {
        display: 'table',
        width: '99%',
        position: 'relative',
        margin: 6,
        padding: 6,
    },
    paymentTypeTypo: {
        width: 120,
    },
    paymentTypeOptions: {
        flexDirection: 'row'
    },
    typoLineHeight: {
        lineHeight: '32px',
    },
    adhocPaymentSwitch: {
        marginRight: 0,
        height: 32
    },
    currencyInput: {
        color: '#000000'
    },
    totalPayableAmountInput: {
        width: '100%',
    },
    form: {
        width: '100%',
    },
    chequeContainer: {
        background: 'rgb(213,239,245)',
        padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit}px`,
    },
    chequeToName: {
        borderBottom: '1px solid #555',
        lineHeight: '100%',
        paddingTop: 4,
    },
    chequeNumber: {
        marginTop: 8,
        padding: '8px 4px',
        height: 34,
        background: 'transparent',
        boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 1px 0px rgba(0, 0, 0, 0.14), 0px -1px 1px -1px rgba(0, 0, 0, 0.12)',
    },
    button: {
        margin: theme.spacing.unit,
        [theme.breakpoints.down('sm')]: {
            marginTop: 16,
            width: '100%',
        }
    },
    cardDisplay:{
        display:"none"
    }
});

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',     
      transform             : 'translate(-50%, -50%)',
      padding               : '0',
      border                : 'none',
      borderRadius          : '0',
      boxShadow             : '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6)',
      overlfow              : 'hidden'
    }
  };
  
class PaymentDetails extends Component {

    constructor(props) {
        super(props);       
        this.state = {
            paymentType: '',
            adhocEnabled: this.props.adhocEnabled,
            adhocPayment: this.props.adhocPayment,
            prepaymentAmount: 0,
            prepayDocumentNos: '',
            paymentHideButton: false,
            paymentProcessing: false,
            focused: '',
            number: '',
            name: '',
            expiry: '',
            cvc: '',
            chequeABANumber: '',
            chequeBankAccountNumber: '',
            isCardValid: false,
            isFormValid: false,
            modalIsOpen:false,
            modalMessage:'',           
            selectedInvoice:[],
            selectedCredits:[],
            selectedCardType:'',
            error: []
        }
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);    
    }

    componentDidMount() {
        this.checkDeclineTransaction()
    }

    componentWillReceiveProps(nextProps) {  
        let selectedInvoiceAmt=[];
        let selectedCreditAmt=[];        
        if (nextProps.adhocPayment !== this.state.adhocPayment) {
            this.setState({ adhocPayment: nextProps.adhocPayment });
        }
        if (nextProps.adhocEnabled !== this.state.adhocEnabled) {
            this.setState({ adhocEnabled: nextProps.adhocEnabled });
        } 
      
      nextProps.invoices.forEach(invoice => {   
            if(invoice.selected){     
                selectedInvoiceAmt.push({
                    invoiceNumber:invoice.invoiceNumber,
                    invoiceDate:invoice.invoiceDate,
                    invoiceAmount:invoice.netAmount,
                    documentType:invoice.documentType,
                    installments:invoice.installments,
                    ccCharge:(invoice.collectCharges==1 && nextProps.paymentType ==='credit' ? 2.95/100 * nextProps.paymentAmounts[invoice.entryNo]:0),
                    //ccCharge:0,
                    entryNo:invoice.entryNo,
                    discountAmount:invoice.discountAmount,
                    paymentAmount:nextProps.paymentAmounts[invoice.entryNo]
                });                         
            }
        });
        nextProps.credits.forEach(credit => {    
            if(credit.selected){
                selectedCreditAmt.push({
                    invoiceNumber:credit.invoiceNumber,
                    invoiceDate:credit.invoiceDate,
                    invoiceAmount:Math.abs(+credit.invoiceAmount),
                    documentType:credit.documentType,
                    paymentAmount:Math.abs(+credit.paymentAmount),
                    entryNo:credit.entryNo                  
                });                                
            }
        }); 
        
        this.setState({
            selectedInvoice: selectedInvoiceAmt,
            selectedCredits: selectedCreditAmt
        });
      let selectedInvoiceAmount = nextProps.invoices.filter(invoice => invoice.selected).reduce((accumulator,invoice) =>{           
            return  accumulator + (+nextProps.paymentAmounts[invoice.entryNo])
       },0);       
      
       let selectedPaymentCreditAmount = nextProps.credits.filter(credit => credit.selected).reduce((accumulator,credit) =>{           
        return  accumulator + (+Math.abs(credit.paymentAmount))
         },0);

        //  if(selectedInvoiceAmount < selectedPaymentCreditAmount && !nextProps.fetchingInvoices && !nextProps.fetchingcredit){
        //     this.handlePaymentTypeChange();         
        //   this.openModal('Invoice amount should be greater than selected Credit Memo');
        //  }                  
    }
    
    openModal = (modalMessage) => {
        this.setState(
            {
                modalIsOpen: true,
                modalMessage: modalMessage
            });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }

    close_modal() {
        this.closeModal()
    }

    close_confirm_modal() {
        this.setState({ modalConfirmIsOpen: false });
        this.profitStars(this.state.netAmount, this.state.serviceCharges);
    }

    confirmModal = (netAmount, serviceCharges) => {
        this.setState(
            {
                modalConfirmIsOpen: true,
                netAmount: netAmount,
                serviceCharges: serviceCharges
            });
    }


    async checkDeclineTransaction() {
          /*** Decline transaction check start *****/
        const onloadDeclTransData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_DECLINETRANS_URL}?customer-code=${this.props['customer']['code']}`,
        {
         method: "GET",
         headers: {        
           'Accept': 'application/json',
           'Content-Type': 'application/json',
            Authorization: `${process.env.REACT_APP_API_TOKEN}`
         }});
   const onloadDeclData = await onloadDeclTransData.json();
   if(onloadDeclData){
       let paymentHideButton = false;
       let errorMessage='';
       if(onloadDeclData.declineCount !=='' && onloadDeclData.declineCount >= 3){
          errorMessage = 'You have reached the maximum decline limit for the day. Please contact your Gabriel & Co. Accounts Receivable Rep for further assistance.';
          paymentHideButton = true;
           this.setState({
              paymentHideButton: paymentHideButton,
              paymentProcessing : false
             })
          this.openModal(errorMessage);
       }
   }
   /*** Decline transaction check end *****/
   };

    handlePaymentTypeChange = (value) => {
        if(value === 'credit' && this.props['customer']['currencyCode'] !== 'CAD'){
            this.openModal("A 2.95% convenience fee will be applied/added to the total amount.")
            //this.openModal("ccservicefeecancel")
        }

        this.props.getPaymentType(value)
        this.setState(prevState => {
            let isValid = false;
            if (value === 'ach') {
                isValid = prevState.chequeABANumber.length > 0 && prevState.chequeBankAccountNumber.length > 0
            } else {
                isValid = prevState.isCardValid && prevState.name.length > 0 && prevState.expiry.length >= 4 && prevState.cvc.length === 3
            }
            return {
                paymentType: value, 
                isFormValid: isValid,
                focused: '',
                number: '',
                name: '',
                expiry: '',
                cvc: '',
                chequeABANumber: '',
                chequeBankAccountNumber: '',
            }
        }); 
    };

    handleAdhocPaymentInput = event => {
        if(this.props.totalInvoiceAmount >= event.target.value){     
            this.setState({adhocPayment: event.target.value});
            this.props.changeAdhocAmount(true, event.target.value);
        }else{
            if (this.props.totalInvoiceAmount !== 0) {
                this.openModal('Payable amount should be less than or equal to the Total Balance Amount');
                this.props.changeAdhocAmount(true, this.props.totalInvoiceAmount);
            } else {
                this.props.changeAdhocAmount(true, event.target.value);
            }
        }
    };

    handlePrepaymentAmountInput = event => {
        const value = event.target.value;
        const numValue = value === '' ? 0 : (parseFloat(value) || 0);
        this.setState({ prepaymentAmount: numValue });
    };

    handlePrepayDocumentNosChange = event => {
        const value = event.target.value;
        if (value.length <= 35) {
            this.setState({ prepayDocumentNos: value });
        }
    };

    handleAdhocAmountInputValidation = () => {
        const actualTotalPayableAmount = this.props.invoices.filter(invoice => invoice.selected).reduce((accumulator, invoice) => {
            return accumulator + (+this.props.paymentAmounts[invoice.entryNo])
        },  0);
        if (actualTotalPayableAmount > 0) {
            if (+this.state.adhocPayment > actualTotalPayableAmount) {
                this.setState({ adhocPayment: actualTotalPayableAmount });
            }
        } else {
            this.setState({ adhocPayment: this.state.adhocPayment });
        }
    }

    toggleAdhoc = () => {
        this.props.invoices.forEach(invoice => {            
                if(invoice.selected){                    
                this.props.toggleInvoice(invoice.entryNo)
                }
        });
        this.props.credits.forEach(credit => {
            if(credit.selected){
                this.props.toggleCredit(credit.entryNo)
            }
        });        
        this.handlePaymentTypeChange();
        this.setState(prevState => {
            if(!prevState.adhocEnabled){
            this.props.changeAdhocAmount(!prevState.adhocEnabled, prevState.adhocPayment);
            this.props.changeCreditAdhocAmount(!prevState.adhocEnabled, prevState.adhocPayment);
            }else{                
            this.props.changeAdhocAmount(!prevState.adhocEnabled,0.00);
            this.props.changeCreditAdhocAmount(!prevState.adhocEnabled, 0.00);
            }           
            return { adhocEnabled: !prevState.adhocEnabled }
        });
    }

    handleInputFocus = ({ target }) => {
        this.setState({
          focused: target.name,
        });
    };

    handleInputChange = ({ target }) => {
        var letterNumber = /^[0-9]+$/;
        if (target.name === 'number') {
          this.setState({
            [target.name]: target.value.replace(/ /g, ''),
          });
        }
        else if (target.name === 'expiry') {
          this.setState({
            [target.name]: target.value.replace(/ |\//g, ''),
          });
        }else if(target.name === 'chequeABANumber' || target.name === 'chequeBankAccountNumber') {
            if(target.value ==='' || target.value.match(letterNumber)){
                this.setState({
                    [target.name]: target.value.replace(/ /g, ''),
                  });
            }
          }else {
          this.setState({
            [target.name]: target.value,
          });
        }
        
    
        this.setState(prevState => {
          let isValid = false;
          let error = [];
          let visacardno = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
          let mastercardno = /^(?:5[1-5][0-9]{14})$/;

          if (prevState.paymentType === 'ach') {
            isValid = prevState.chequeABANumber.length === 9 && prevState.chequeBankAccountNumber.length >=4
            if(prevState.chequeABANumber !=='' && prevState.chequeABANumber.length !== 9){
                error['route']= 'Please enter valid routing number';
            }else{
              error['route'] = '';
            }
            if(prevState.chequeBankAccountNumber !=='' && prevState.chequeBankAccountNumber.length < 4){
                error['bankNumber']= 'Please enter valid bank account number';
            }else{
              error['bankNumber'] = '';
            }
          } else {
            isValid = prevState.isCardValid && prevState.name.length > 0 && prevState.expiry.length >= 4 && prevState.cvc.length >= 3
        }
       
        if(prevState.isCardValid !== '' && !prevState.isCardValid){
            error['cardNumber']= 'Please enter valid card number.';
        }else{
            if(this.props['customer']['currencyCode'] === 'CAD' && !this.state['number'].match(visacardno) && !this.state['number'].match(mastercardno)){
                isValid = false;
                error['cardNumber']= 'Please enter valid type of cards.';
            }else{
              error['cardNumber'] = '';
           }
        }
        if(prevState.name !== '' && prevState.name.length < 3){
          error['name']= 'Please enter name.';
      }else{
        error['name'] = '';
      }
      if(prevState.expiry !=='' && prevState.expiry.length < 6){
          error['expiry']= 'Please enter valid expiry date.';
      }else{
        error['expiry'] = '';
      }
      if(prevState.cvc !=='' && prevState.cvc.length < 3){
          error['cvc']= 'Please enter valid cvc number.';
      }else{
        error['cvc'] = '';
      }
          return {
            isFormValid: isValid,
            error: error
          }
        })
    };

    handleCallback = (type, isValid) => {
        this.setState(prevState => {
          let isFormValid = isValid && prevState.name.length > 0 && prevState.expiry.length >= 4 && prevState.cvc.length >= 4
          return {
            isCardValid: isValid,
            isFormValid: isFormValid
          }
        })
    }
   async storeSelectedData(netAmount,serviceCharges){
       
       let totalInvoiceAmount = this.props.invoices.filter(invoice => invoice.selected).reduce((accumulator, invoice) => {                
        return accumulator + (+this.props.paymentAmounts[invoice.entryNo])
    },  0)
    let totalCreditMemoAmount = this.props.credits.filter(creditMemo => creditMemo.selected).reduce((accumulator,creditMemo) =>{        
        return accumulator + (+this.props.paymentAmountsCreditMemo[creditMemo.entryNo]);  
   },0)
  
//    if(totalInvoiceAmount === totalCreditMemoAmount){
//     this.openModal("Invoice amout should be greater than selected credit memo.")
//    }else{
       this.setState({
        paymentHideButton: true
       })
    this.openModal('loading');
    if(!this.state.paymentProcessing){
        this.state.paymentProcessing = true;
        this.setState({
            paymentProcessing: true
        })
        this.navPostPaymentDetails(null,netAmount,serviceCharges);
    }
//    }    
}

navPostPaymentDetails = (response,netAmount,serviceCharges) => {
    let creditCardNumber = this.state['number'];
    let object = Object.assign({},
        {
            isPrepayment: this.props.isPrepayment || false,
            prepayDocumentNos: this.state.prepayDocumentNos || '',
            customerCode: this.props['customer']['code'],
            customerName: this.props['customer']['name'],
            invoiceAddress1: this.props['customer']['address1'],
            invoiceAddress2: this.props['customer']['invoiceAddress2'],
            invoiceCity: this.props['customer']['city'],
            invoiceState: this.props['customer']['state'],
            invoiceZip: this.props['customer']['zipcode'],
            invoicePhone: this.props['customer']['phone'],
            postingDate: dateFormat(new Date(), "mm/dd/yy"),
            transactionId: '',
            paymentAmount: netAmount.toFixed(2),
            creditCardCharge: serviceCharges,
            paymentMethod: this.state.paymentType === 'credit' ? 'Credit Card' : this.state.paymentType === 'debit' ? 'Debit Card' : this.state.paymentType,
            cardType: '',
            creditCardNumber: creditCardNumber,
            transactionDate: dateFormat(new Date(), "mm/dd/yy"),
            transactionTime: dateFormat(new Date(), "hh:mm:ss TT"),
            currencyCode: this.props.currencyCode,
            invoiceDetails: this.state.selectedInvoice,
            creditmemoDetails: this.state.selectedCredits,
            documentNo: '',
            totalInvoiceAmount: this.props.invoices.filter(invoice => invoice.selected).reduce((accumulator, invoice) => {
                return accumulator + (+this.props.paymentAmounts[invoice.entryNo])
            }, 0),
            totalCreditMemoAmount: this.props.credits.filter(creditMemo => creditMemo.selected).reduce((accumulator, creditMemo) => {
                return accumulator + (+this.props.paymentAmountsCreditMemo[creditMemo.entryNo]);
            }, 0),
            paymentResponseData: '',
            paymentResponseCode: '',
            expirationDate: this.state['expiry'],
            cardCode: this.state['cvc'],
            firstName: this.state['name'],
            country: this.props['customer']['country']
        });                                          
      this.saveNavPost(object)  
}


async profitStars(netAmount,serviceCharges){
    this.setState({
        paymentHideButton: true
    })
    this.openModal('loading');
    if (!this.state.paymentProcessing) {
        this.state.paymentProcessing = true;
        this.setState({
            paymentProcessing: true
        })
        let creditCardNumber = this.state['chequeBankAccountNumber'];
        let object = Object.assign({},
        {
            isPrepayment: this.props.isPrepayment || false,
            prepayDocumentNos: this.state.prepayDocumentNos || '',
            customerCode: this.props['customer']['code'],
            customerName: this.props['customer']['name'],
            invoiceAddress1: this.props['customer']['address1'],
            invoiceAddress2: this.props['customer']['invoiceAddress2'],
            invoiceCity: this.props['customer']['city'],
            invoiceState: this.props['customer']['state'],
            invoiceZip: this.props['customer']['zipcode'],
            invoicePhone: this.props['customer']['phone'],
            postingDate: dateFormat(new Date(), "mm/dd/yy"),
            transactionId: null,
            paymentAmount: netAmount.toFixed(2),
            creditCardCharge: serviceCharges,
            paymentMethod: this.state.paymentType,
            cardType: null,
            creditCardNumber: creditCardNumber ? creditCardNumber : '',
            transactionDate: dateFormat(new Date(), "mm/dd/yy"),
            transactionTime: dateFormat(new Date(), "hh:mm:ss TT"),
            currencyCode: this.props.currencyCode,
            invoiceDetails: this.state.selectedInvoice,
            creditmemoDetails: this.state.selectedCredits,
            documentNo: this.state['chequeABANumber'],
            totalInvoiceAmount: this.props.invoices.filter(invoice => invoice.selected).reduce((accumulator, invoice) => {
                return accumulator + (+this.props.paymentAmounts[invoice.entryNo])
            }, 0),
            totalCreditMemoAmount: this.props.credits.filter(creditMemo => creditMemo.selected).reduce((accumulator, creditMemo) => {
                return accumulator + (+this.props.paymentAmountsCreditMemo[creditMemo.entryNo]);
            }, 0),
            paymentResponseData: '',
            paymentResponseCode: '',
            expirationDate: '',
            cardCode: '',
            firstName: '',
            country: ''
        });

 const paymentSavedResponseData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PROFIT}`,
    {
     method: "POST",
     headers: {        
        Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
     body: JSON.stringify(object)
    });
 
 
    const data = await paymentSavedResponseData.json();
    if(data){
        localStorage.setItem('paidData', JSON.stringify(data));
        localStorage.setItem('customer',JSON.stringify(this.props.customer));
        if(data.paymentResponseCode === '1'){
            history.push('success'); 
            this.setState({
                paymentHideButton: false,
                paymentProcessing : false
               })
        }else{
            let profitstarmsg = 'Payment is not processed. Please try again later (or) contact our customer care.';
            let paymentHideButton = false;
            const declineTransactionData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_DECLINETRANS_URL}?customer-code=${this.props['customer']['code']}`,
            {
             method: "GET",
             headers: {        
               'Accept': 'application/json',
               'Content-Type': 'application/json',
                Authorization: `${process.env.REACT_APP_API_TOKEN}`
             }});
            let declineData = await declineTransactionData.json();
            declineData = declineData && declineData.length ? declineData[0] : {};
            if(declineData){
                let errorMessage = '';
                if(declineData.declineCount !=='' && declineData.declineCount == 1){
                   errorMessage = 'You have 2 more attempts left. Please use an active credit / debit / ACH account details for payment.';
                }
                if(declineData.declineCount !=='' && declineData.declineCount == 2){
                   errorMessage = 'You have 1 more attempt left. Please use an active credit / debit / ACH account details for payment.';
                }
                if(declineData.declineCount !=='' && declineData.declineCount >= 3){
                   errorMessage = 'You have reached the maximum decline limit for the day. Please contact your Gabriel & Co. Accounts Receivable Rep for further assistance.';
                   paymentHideButton = true;
                }
                profitstarmsg = errorMessage+'#;'+profitstarmsg;
           }
           this.setState({
            paymentHideButton: paymentHideButton,
            paymentProcessing : false
           })
           this.openModal(profitstarmsg);
        }     
    }else{
        let apiErrorMsg = data;
        if(apiErrorMsg.indexOf('could not execute statement') !== -1){
            apiErrorMsg = 'Service Error. Please try after some time.'
        }
        this.setState({
            paymentHideButton: false,
            paymentProcessing : false
           })
        this.openModal(apiErrorMsg);
    }
} 
}

async saveNavPost(object) {
    const paymentSavedResponseData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_SAVEPAYMENT_URL}`,
    {
     method: "POST",
     headers: {        
        Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
     body: JSON.stringify(object)
    });

    const data = await paymentSavedResponseData.json();
    if(data && !data.message){
        localStorage.setItem('paidData', JSON.stringify(data));
        localStorage.setItem('customer',JSON.stringify(this.props.customer));
        if(data.transactionId && data.paymentResponseData && data.paymentResponseCode ){
            if(data.paymentResponseCode === '1'){
                history.push('success');
                this.setState({
                    paymentHideButton: false,
                    paymentProcessing : false
                   })
            }else{
                // let declineObject = Object.assign({},
                //     {customerCode:this.props['customer']['code']});
             const declineTransactionData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_DECLINETRANS_URL}?customer-code=${this.props['customer']['code']}`,
             {
              method: "GET",
              headers: {        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                 Authorization: `${process.env.REACT_APP_API_TOKEN}`
              }});
             let declineData = await declineTransactionData.json();
             declineData = declineData && declineData.length ? declineData[0] : {};
             if(declineData){
                 let errorMessage = '';
                 let paymentHideButton = false;
               
                 if(declineData.declineCount !=='' && declineData.declineCount == 1){
                    errorMessage = 'You have 2 more attempts left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount == 2){
                    errorMessage = 'You have 1 more attempt left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount >= 3){
                    errorMessage = 'You have reached the maximum decline limit for the day. Please contact your Gabriel & Co. Accounts Receivable Rep for further assistance.';
                    paymentHideButton = true;
                 }
                 errorMessage = errorMessage+'#;'+data.paymentErrorMsg;
                this.setState({
                    paymentHideButton: paymentHideButton,
                    paymentProcessing : false
                   })
                this.openModal(errorMessage);
             }
            }
        }else{
            if(data.totalInvoiceAmount === data.totalCreditMemoAmount && data.paymentAmount === '0.00'){
                history.push('success');
                this.setState({
                    paymentHideButton: false,
                    paymentProcessing : false
                   })
            }else{
             const declineTransactionData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_DECLINETRANS_URL}?customer-code=${this.props['customer']['code']}`,
             {
              method: "GET",
              headers: {        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                 Authorization: `${process.env.REACT_APP_API_TOKEN}`
              }});
             let declineData = await declineTransactionData.json();
             declineData = declineData && declineData.length ? declineData[0] : {};
             if(declineData){
                 let errorMessage = '';
                 let paymentHideButton = false;
                 
                 if(declineData.declineCount !=='' && declineData.declineCount == 1){
                    errorMessage = 'You have 2 more attempts left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount == 2){
                    errorMessage = 'You have 1 more attempt left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount >= 3){
                    errorMessage = 'You have reached the maximum decline limit for the day. Please contact your Gabriel & Co. Accounts Receivable Rep for further assistance.';
                    paymentHideButton = true;
                 }
                 errorMessage = errorMessage+'#;'+data.paymentErrorMsg;
                this.setState({
                    paymentHideButton: paymentHideButton,
                    paymentProcessing : false
                   })
                this.openModal(errorMessage);
               }
            }
        }
    }else{
        let paymentHideButton = false;
        let apiErrorMsg = data.message;
        if(apiErrorMsg.indexOf('could not execute statement') !== -1){
            apiErrorMsg = 'Service Error. Please try after some time.';
        }
        else if(apiErrorMsg.indexOf('already been paid') !== -1 || apiErrorMsg.indexOf('currently being processed') !== -1 || apiErrorMsg.indexOf('payment amount is greater then the invoice amount') !== -1){
            apiErrorMsg = apiErrorMsg;
        }
        else{
            const declineTransactionData = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_DECLINETRANS_URL}?customer-code=${this.props['customer']['code']}`,
             {
              method: "GET",
              headers: {        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                 Authorization: `${process.env.REACT_APP_API_TOKEN}`
              }});
             let declineData = await declineTransactionData.json();
             declineData = declineData && declineData.length ? declineData[0] : {};
             if(declineData){
                 let errorMessage = '';
                 if(declineData.declineCount !=='' && declineData.declineCount == 1){
                    errorMessage = 'You have 2 more attempts left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount == 2){
                    errorMessage = 'You have 1 more attempt left. Please use an active credit / debit / ACH account details for payment.';
                 }
                 if(declineData.declineCount !=='' && declineData.declineCount >= 3){
                    errorMessage = 'You have reached the maximum decline limit for the day. Please contact your Gabriel & Co. Accounts Receivable Rep for further assistance.';
                    paymentHideButton = true;
                 }
                 apiErrorMsg = errorMessage+'#;'+apiErrorMsg;
               }
        }   
        this.setState({
            paymentHideButton: paymentHideButton,
            paymentProcessing : false
           })
        this.openModal(apiErrorMsg);
    }  
}  
    getParent() {       
          return document.getElementsByTagName('body')[0];       
      }
    render() {
        const { paymentType, adhocEnabled, adhocPayment, prepaymentAmount, number, name, expiry, cvc, focused,
            chequeABANumber, chequeBankAccountNumber, isFormValid } = this.state;
        const { classes, invoices, paymentAmounts,credits,paymentAmountsCreditMemo, isPrepayment = false } = this.props;   
        let invoiceTotalPayableAmount = invoices.filter(invoice => invoice.selected).reduce((accumulator, invoice) => {                
            return accumulator + (+paymentAmounts[invoice.entryNo])
        },  0);
        let creditTotalPayableAmount = credits.filter(creditMemo => creditMemo.selected).reduce((accumulator,creditMemo) =>{        
             return accumulator + (+paymentAmountsCreditMemo[creditMemo.entryNo]);  
        },0);                  
        const actualTotalPayableAmount = invoiceTotalPayableAmount - creditTotalPayableAmount;                       
        const totalPayableAmount = isPrepayment ? (Number(prepaymentAmount) || 0) : (adhocEnabled ? adhocPayment : actualTotalPayableAmount);
        // const serviceCharges = invoices.filter(invoice => invoice.selected).reduce((accumulator,invoice) => {
        //             return accumulator+(invoice.collectCharges == 1 && paymentType === 'credit' ? 1.75/100*totalPayableAmount:0)
        // },0);     
        let serviceCharges = 0;
        invoices.map(invoice => {
            if(invoice.selected && invoice.collectCharges == 1 && paymentType === 'credit' && this.props['customer']['currencyCode'] !== 'CAD' && totalPayableAmount > 0){ 
                let charge =  2.95/100*totalPayableAmount;              
                serviceCharges = Number(charge.toFixed(2));
            }
        });

        if(paymentType === 'credit' &&  this.props['customer']['currencyCode'] !== 'CAD' ){
            let charge =  2.95/100*totalPayableAmount;              
            serviceCharges = Number(charge.toFixed(2));
        }

        let netAmount = 0;
        if(totalPayableAmount > 0){
          netAmount = Number(totalPayableAmount.toFixed(2)) + serviceCharges;
       }
        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        const displayCardInfo = (paymentType === 'credit' || paymentType === 'debit');
        const displayACHInfo = paymentType === 'ach';
        return (
            <Paper className={classes.root}>
                  {this.props['customer']['currencyCode'] === 'CAD' && <Grid item xs={12} sm="auto" className='cad-supportedCards' style={{fontWeight: '500',color:'#fa451c', fontSize: '1rem'}}>
                  {/* <img src={card_master} style = {window.innerWidth > 768 ? {height: '30px', width: '3%', float: 'left',marginRight:'15px'} : {height: '30px', width: '3%', float: 'left',marginRight:'15px'}} />
                  <img src={card_visa} style = {window.innerWidth > 768 ? {height: '16px', width: '3%', float: 'left',top:'8px',position:'relative'} : {height: '16px', width: '3%', float: 'left',top:'8px',position:'relative'}} /> */}
                  <img src={visa_master} style = {window.innerWidth > 768 ? {height: '100%', width: '11%', float: 'left'} : {height: '100%', width: '30%', float: 'left'}} />
                 </Grid>}
                <Grid container spacing={8} alignItems="center">
                    <Grid item xs={12} sm={7}>
                        <Grid container alignItems="center" spacing={8}>
                            <Grid item className={classes.paymentTypeTypo}>
                                <Typography variant="subheading">Payment type: </Typography>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <FormControl component="fieldset" required>
                                    <RadioGroup
                                        aria-label="payment type"
                                        name="paymentType"
                                        className={classes.paymentTypeOptions}
                                        value={this.state.paymentType}
                                        onChange={(event) => this.handlePaymentTypeChange(event.target.value)}                                    
                                    >
                                        {this.props['customer']['currencyCode'] !== 'CAD' && <FormControlLabel  value="debit" control={<Radio />} label="Debit" />}
                                        <FormControlLabel value="credit" control={<Radio />} label="Credit" />
                                        {this.props['customer']['currencyCode'] !== 'CAD' && <FormControlLabel  value="ach"  control={<Radio />} label="ACH" />}
                                        {netAmount !== 0 && (displayACHInfo || displayCardInfo) ?
                                        <div style={{display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.87)', fontSize: '1rem'}}> Please enter the&nbsp;<span style={{color: 'rgb(250, 69, 28)'}}>{displayCardInfo ? 'card details' : 'account details'}</span>&nbsp;below.
                                        <i className="fa fa-arrow-down" aria-hidden="true" style={{color: 'rgb(250, 69, 28)'}}></i>
                                        </div> : ''}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={7} sm="auto">
                                <Typography variant="subheading" align="right" className={classes.typoLineHeight}>Total payable amount : </Typography>
                                <Typography variant="subheading" align="right" className={classes.typoLineHeight}>Service charges : </Typography>
                                <Typography variant="subheading" align="right" className={classes.typoLineHeight}>Net Amount : </Typography>
                            </Grid>
                            <Grid item xs={5} sm="auto">
                                {/* <Typography variant="subheading" align="right" className={classes.typoLineHeight}> */}
                                {isPrepayment ? (
                                    <Typography variant="subheading" align="right" className={classes.typoLineHeight}>
                                        <NumberFormat value={totalPayableAmount}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            displayType={'text'} thousandSeparator={true} prefix={this.props['customer']['currencyCode'] ==='CAD' ? 'CAD ':'$'}
                                        />
                                    </Typography>
                                ) : (
                                    <TextField 
                                        className={classes.totalPayableAmountInput}
                                        value={totalPayableAmount}
                                        disabled={!adhocEnabled}
                                        onChange={this.handleAdhocPaymentInput}
                                        onBlur={this.handleAdhocAmountInputValidation}
                                        InputProps={{
                                            inputComponent: CurrencyInputFormat,
                                        }}
                                        inputProps={{
                                            className: this.props.classes.currencyInput,
                                            currencyCode:this.props['customer']['currencyCode'],
                                        }}
                                    />
                                )}
                                 <Typography variant="subheading" align="right" className={classes.typoLineHeight}>
                                    <NumberFormat value={serviceCharges}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        displayType={'text'} thousandSeparator={true} prefix={this.props['customer']['currencyCode'] ==='CAD' ? 'CAD ':'$'}
                                    />
                                </Typography> 
                                <Typography variant="subheading" align="right" className={classes.typoLineHeight}>
                                    <NumberFormat value={netAmount}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        displayType={'text'} thousandSeparator={true} prefix={this.props['customer']['currencyCode'] ==='CAD' ? 'CAD ':'$'}
                                    />
                                </Typography>
                            </Grid>
                            {!isPrepayment && <Grid item>
                                <FormControlLabel className={classes.adhocPaymentSwitch} control={<Switch checked={adhocEnabled} onChange={this.toggleAdhoc}/>} label="Adhoc Payment" />                              
                                {adhocEnabled && <Hidden smUp>
                                    <Typography variant="subheading" align="right" className={classes.typoLineHeight}>
                                        You can edit Total payable amount
                                    </Typography>
                                </Hidden>}
                            </Grid>}
                        </Grid>
                        {isPrepayment && (displayCardInfo || displayACHInfo) && (
                            <Grid container spacing={8} style={{ marginTop: 8, marginBottom: 8 }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Prepayment Amount"
                                        value={prepaymentAmount}
                                        onChange={this.handlePrepaymentAmountInput}
                                        InputProps={{
                                            inputComponent: CurrencyInputFormat,
                                        }}
                                        inputProps={{
                                            className: this.props.classes.currencyInput,
                                            currencyCode: this.props['customer']['currencyCode'],
                                        }}
                                    />
                                    <TextField
                                        fullWidth
                                        label="Prepay Document Nos"
                                        value={this.state.prepayDocumentNos}
                                        onChange={this.handlePrepayDocumentNosChange}
                                        inputProps={{ maxLength: 35 }}
                                        style={{ marginTop: 16 }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        {displayCardInfo &&<CardDetails 
                            error={this.state.error}
                            handleCallback={this.handleCallback}
                            handleInputFocus={this.handleInputFocus}
                            handleInputChange={this.handleInputChange}
                            number={number}
                            name={name}
                            expiry={expiry}
                            cvc={cvc}
                            focused={focused}
                            key={paymentType}
                        /> }
                        {displayACHInfo && 
                            <div style={{display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.87)', fontSize: '9pt', color: 'rgb(250, 69, 28)'}}>*Please enter your correct account and routing number to avoid a chargeback from your bank.<br />Note that it will take 2 business days to verify that your ACH payment has cleared with Gabriel & Co.
                            </div>}
                        {displayACHInfo && <Grid container spacing={24}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="chequeABANumber">Routing No</InputLabel>
                                    <Input
                                        id="chequeABANumber"
                                        name="chequeABANumber"
                                        value={chequeABANumber}
                                        onChange={this.handleInputChange}
                                         inputProps={{                                          
                                            maxLength:9
                                        }}>                                            
                                        </Input>
                                        <div style={{margin: '5px',fontSize: '13px', color: 'red'}}>{this.state.error['route']}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="chequeBankAccountNumber">Bank Account Number</InputLabel>
                                    <Input
                                        id="chequeBankAccountNumber"
                                        name="chequeBankAccountNumber"
                                        value={chequeBankAccountNumber}
                                        onChange={this.handleInputChange}
                                        inputProps={{                                         
                                            maxLength:17
                                        }}
                                    />
                                    <div style={{margin: '5px',fontSize: '13px', color: 'red'}}>{this.state.error['bankNumber']}</div>
                                </FormControl>
                            </Grid>
                        </Grid>}
                    </Grid>
                    {displayCardInfo &&<Hidden only="xs">
                        <Grid className={classNames({
                    [classes.cardDisplay]: isIE,
                })} item sm={5}>
                            <Cards                            
                                number={number}
                                name={name}
                                expiry={expiry}
                                cvc={cvc}
                                focused={focused}
                                callback={this.handleCallback}
                            />
                        </Grid>
                    </Hidden>}
                    {displayACHInfo && <Hidden smDown>
                        <Grid className={classNames({
                    [classes.cardDisplay]: isIE,
                })} item sm={5}>
                            <Paper className={classes.chequeContainer} elevation={1}>
                            <Typography variant="body1" component="h3">
                                Pay to the order of
                            </Typography>
                            <Typography variant="body2" component="h3" className={classes.chequeToName}>
                                Gabriel &amp; Co
                            </Typography>
                            <Grid container spacing={24}>
                                <Grid item sm={3}>
                                    <Paper className={classes.chequeNumber}>{chequeABANumber}</Paper>
                                    <Typography variant="body1" component="h3">
                                       Routing No.
                                    </Typography>
                                </Grid>
                                <Grid item sm={6}>
                                    <Paper className={classes.chequeNumber}>{chequeBankAccountNumber}</Paper>
                                    <Typography variant="body1" component="h3">
                                        Bank Account No.
                                    </Typography>
                                </Grid>
                                <Grid item sm={3}>
                                    <Paper className={classes.chequeNumber}>
                                        <NumberFormat value={netAmount}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            displayType={'text'} thousandSeparator={true} prefix={this.props['customer']['currencyCode'] ==='CAD' ? 'CAD ':'$'}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            </Paper>
                        </Grid>
                    </Hidden>}
                </Grid> 
                <Grid container spacing={8} justify="flex-end">
                {isFormValid && netAmount > 0 && this.state.paymentType !== 'ach' && !this.state.paymentHideButton &&
                    <div>
                <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Do not double click,</p>
                <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Please click the button once and wait for the response from the system.</p>
                <Button variant="contained" color="primary" style={{float: 'right'}}
                        className={classes.button}
                        onClick={() => this.storeSelectedData(netAmount,serviceCharges)}                        
                    >                    
                        Proceed to Pay
                </Button> </div> }
                {isFormValid && netAmount >0 && this.state.paymentType === 'ach' && !this.state.paymentHideButton &&
                <div>
               <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Do not double click,</p>
                <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Please click the button once and wait for the response from the system.</p>
                    <Button variant="contained" color="primary" style={{float: 'right'}}
                        className={classes.button}
                        onClick={() => this.confirmModal(netAmount,serviceCharges)}                        
                    >                    
                        Proceed to Pay
                </Button> </div>}

                {!this.state.paymentHideButton && invoiceTotalPayableAmount !=0 && creditTotalPayableAmount !=0 && invoiceTotalPayableAmount == creditTotalPayableAmount &&  this.state.paymentType !== 'ach' &&
                 <div>
               <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Do not double click,</p>
                <p style={{margin: '0px', textAlign: 'right', fontSize: '13px', color: 'red'}}>* Please click the button once and wait for the response from the system.</p>
                <Button variant="contained" color="primary"  style={{float: 'right'}}
                 className={classes.button}
                 onClick={() => this.storeSelectedData(netAmount,serviceCharges,invoiceTotalPayableAmount,creditTotalPayableAmount)}                        
             >             
                 Proceed to Pay
         </Button> </div>}                                                          
                </Grid> 
                <OpenModal 
                customStyles={customStyles} modalIsOpen={this.state.modalIsOpen}
                closeModal={this.closeModal} getParent={this.getParent}
                closeOnClick={this.close_modal.bind(this)} 
                modalMessage={this.state.modalMessage}>
                </OpenModal>
                <ConfirmModal
                customStyles={customStyles} modalIsOpen={this.state.modalConfirmIsOpen}
                closeModal={this.close_confirm_modal.bind(this)} getParent={this.getParent}
                closeOnClick={this.close_confirm_modal.bind(this)} >                
                </ConfirmModal>
            </Paper>            
        );
    }
}

PaymentDetails.propTypes = {
    classes: PropTypes.object.isRequired,
    isPrepayment: PropTypes.bool,
};

const mapStateToProps = state => ({
    customer: state.auth.customer,
    invoices: state.invoice.invoices,
    credits: state.credit.credit,
    currencyCode:state.invoice.currencyCode,
    ccserviceCharge:state.invoice.ccserviceCharge,
    paymentAmounts: state.invoice.paymentAmounts,
    paymentAmountsCreditMemo: state.credit.paymentAmounts,
    adhocPayment: state.invoice.adhocPayment,
    adhocEnabled: state.invoice.adhocPaymentEnabled,
    successPaymentInprogress:state.invoice.successPaymentInprogress,
    fetchingcredit: state.credit.fetching,
    fetchingInvoices: state.invoice.fetching,
    paymentType:state.invoice.paymentType,
    totalInvoiceAmount:state.invoice.totalInvoiceAmount
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchInvoices,
    toggleAllInvoices,
    toggleInvoice,
    changeAdhocAmount,
    changeCreditAdhocAmount,
    getPaymentType,
    toggleCredit
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PaymentDetails));


// WEBPACK FOOTER //
// ./src/PaymentDetails.js